// extracted by mini-css-extract-plugin
export default {"footer":"TableFooter_footer__mM1wd","section":"TableFooter_section__7h6zt","text":"TableFooter_text__XJ-q9"};